import { DefaultStatalCategoryId } from '../redux/category/model';
import { LeagueRankingColors, LeagueSettings } from '../redux/league/model';

export const greenLeagueRanking: React.CSSProperties = {
    backgroundColor: '#44cf9c',
    color: 'rgb(50, 58, 70)',
};
export const yellowLeagueRanking: React.CSSProperties = {
    backgroundColor: '#eaa448',
    color: 'rgb(50, 58, 70)',
};
export const redLeagueRanking: React.CSSProperties = {
    backgroundColor: '#f86262',
    color: 'rgb(50, 58, 70)',
};

// las posiciones se guardan empezando en 1, igual que se ven en la clasificación
export const defaultCategoryRankingColors: { [categoryId: number]: LeagueRankingColors } = {
    [DefaultStatalCategoryId.SUPERAUTONOMICA]: { green: [1, 2, 3], yellow: [8], red: [9, 10] },
    [DefaultStatalCategoryId.PRIMERA_AUTONOMICA]: { green: [1], yellow: [2, 3], red: [9, 10] },
    [DefaultStatalCategoryId.SEGUNDA_AUTONOMICA]: { green: [], yellow: [1, 2, 3], red: [] },
};

export const emptyRankingColors = (): LeagueRankingColors => ({ green: [], yellow: [], red: [] });

/**
 * Colores que se aplican a una liga: los suyos propios si el administrador los ha
 * personalizado, y si no los de su categoría.
 */
export const getLeagueRankingColors = (categoryId?: number, settings?: LeagueSettings): LeagueRankingColors =>
    settings?.rankingColors ??
    (categoryId !== undefined ? defaultCategoryRankingColors[categoryId] : undefined) ??
    emptyRankingColors();

export const MAX_RANKING_POSITION = 99;

/**
 * '1-3, 8' => [1, 2, 3, 8]
 */
export const parseRankingPositions = (value?: string): number[] => {
    const positions = new Set<number>();
    (value ?? '').split(',').forEach((chunk: string) => {
        const [from, to] = chunk.split('-').map((part: string) => parseInt(part.trim(), 10));
        if (isNaN(from) || from < 1) return;
        const last = isNaN(to) ? from : to;
        for (let position = from; position <= last && position <= MAX_RANKING_POSITION; position++) {
            positions.add(position);
        }
    });
    return Array.from(positions).sort((a: number, b: number) => a - b);
};

/**
 * [1, 2, 3, 8] => '1-3, 8'
 */
export const formatRankingPositions = (positions?: number[]): string => {
    const sorted = Array.from(new Set(positions ?? [])).sort((a: number, b: number) => a - b);
    const ranges: string[] = [];
    let start = 0;
    for (let i = 0; i < sorted.length; i++) {
        if (i > 0 && sorted[i] === sorted[i - 1] + 1) continue;
        if (i > 0) ranges.push(start === sorted[i - 1] ? `${start}` : `${start}-${sorted[i - 1]}`);
        start = sorted[i];
    }
    if (sorted.length > 0) {
        const last = sorted[sorted.length - 1];
        ranges.push(start === last ? `${start}` : `${start}-${last}`);
    }
    return ranges.join(', ');
};
